const o="roq-ui.";export{o as COMPONENT_TRANSLATION_KEY_PREFIX};